import { Award, BadgeCheck, ScrollText, FileCheck2, Globe2, Stamp } from "lucide-react";
import { SectionHeader } from "./Section";
import apiLogo from "/src/assets/APILogo.png";
import Iso9001Log from "/src/assets/ISO9001.png";
import Iso45001 from "/src/assets/Iso45001.png";
import LEEA from "/src/assets/LEEALogo.png";
import DNV from "/src/assets/DNV.png";
import ASNT from "/src/assets/ASNT.png";
const BADGES = [
  {
    logo: apiLogo,
    code: "API",
    label: "American Petroleum Institute",
  },
  {
    logo: Iso9001Log,
    code: "ISO 9001",
    label: "Quality Management",
  },
  {
    logo: Iso45001,
    code: "ISO 45001",
    label: "Occupational H&S",
  },
  {
    logo: LEEA,
    code: "LEEA",
    label: "Lifting Equipment Engineers Association",
  },
  { logo: DNV, code: "DNV", label: "Det Norske Veritas", desc: "Approved offshore standards" },
  {
    logo: ASNT,
    code: "ASNT",
    label: "NDT Certification",
  },
];

export function Certifications() {
  return (
   /*  <section id="certifications" className="section-y bg-light-gray">
      <div className="container-x">
        <SectionHeader
          eyebrow="Accreditation & Certifications"
          title="Independently accredited. Internationally recognised."
          intro="Our inspectors, processes and quality systems are accredited against the world's most demanding industrial and offshore standards."
          align="center"
        />

        <div className="mt-14 grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-4">
          {BADGES.map((b) => (
            <div
              key={b.code}
              className="group flex flex-col items-center rounded-xl border border-border bg-card p-6 text-center transition-all hover:-translate-y-1 hover:border-orange hover:shadow-xl"
            >
            <div className="flex h-24  items-center justify-center">
  <img
    src={b.logo}
    
    className="h-36 w-auto object-contain transition-transform duration-300 group-hover:scale-100"
  />
</div>
              <div className="mt-6 text-lg font-black text-navy-deep">{b.code}</div>
              <div className="mt-1 text-xs font-semibold uppercase tracking-wider text-orange">
                {b.label}
              </div>
            
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl border border-border bg-card p-8 text-center">
          <p className="mx-auto max-w-3xl text-base text-muted-foreground">
            All certificates are issued under the authority of an accredited inspection body and are
            recognised by operators, classification societies and regulatory authorities worldwide.
          </p>
        </div>
      </div>
    </section> */
    <section id="certifications" className="section-y bg-white">
  <div className="container-x">

    <SectionHeader
      eyebrow="Accreditation & Certifications"
      title="Recognized Industry Standards"
      intro="Our team operates in accordance with internationally recognized standards and industry best practices across inspection, certification, and engineering services."
      align="center"
    />

    <div className="mt-16 rounded-3xl border border-border bg-card p-8 lg:p-12">

      <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-6">

        {BADGES.map((b) => (
          <div
            key={b.code}
            className="group flex flex-col items-center justify-center"
          >
            <div className="flex h-28 items-center justify-center">
              <img
                src={b.logo}
                alt={b.code}
                className="max-h-20 w-auto object-contain grayscale transition-all duration-300 group-hover:grayscale-0 group-hover:scale-110"
              />
            </div>

            <div className="mt-4 text-center">
              <div className="text-base font-bold text-navy-deep">
                {b.code}
              </div>

              <div className="mt-1 text-xs text-muted-foreground">
                {b.label}
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>

    <div className="mt-12 rounded-3xl bg-navy-deep p-8 text-center text-white">

      <div className="text-xl font-bold">
        Commitment to International Standards
      </div>

      <p className="mx-auto mt-4 max-w-4xl text-white/75">
        Our inspectors and engineers work in alignment with internationally
        recognized standards and best practices, supporting clients across
        offshore, marine, energy, lifting, and industrial sectors with a strong
        focus on safety, compliance, and technical excellence.
      </p>

    </div>

  </div>
</section>
  );
}
